import { styled, secondaryFontFamily } from '@openeducation/oe-it-themes';
import React, { memo } from 'react';

import HoverableButton from '../../atoms/hoverable-button/hoverable-button';
import { OEText } from '../../atoms/oe-text/oe-text';
import { ph, pt, pb } from '../../style-utils';

export interface NavItemProps {
  label: string;
  onPress: () => void;
  spacing?: number;
  isActive?: boolean;
}

const NavItem = ({ label, onPress, spacing = 20, isActive }: NavItemProps) => {
  return (
    <HoverableButton onPress={onPress} style={[ph(spacing), pt(10), pb(8)]}>
      {(isHovered) => (
        <Wrapper underline={isActive || isHovered}>
          <NavItemText fontType={isActive ? 'bold' : 'medium'}>
            {label}
          </NavItemText>
        </Wrapper>
      )}
    </HoverableButton>
  );
};

const NavItemText = styled(OEText).attrs(({ theme }) => ({
  color: theme.color.black,
  fontSize: 18,
  fontFamily: secondaryFontFamily,
}))``;

type WrapperProps = {
  underline?: boolean;
};

const Wrapper = styled.View<WrapperProps>`
  border-bottom-width: 2px;
  border-bottom-color: ${({ theme, underline }) =>
    underline ? theme.color.primary : 'transparent'};
`;

export default memo(NavItem);
